"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.services = exports.random = exports.plist = exports.platform = exports.net = exports.localizer = exports.host = exports.cryptography = exports.cookieProvider = exports.bundle = exports.bag = void 0;
const metatype_1 = require("../../util/metatype");
exports.bag = metatype_1.makeMetatype("jet-engine:bag");
exports.bundle = metatype_1.makeMetatype("jet-engine:bundle");
exports.cookieProvider = metatype_1.makeMetatype("jet-engine:cookieProvider");
exports.cryptography = metatype_1.makeMetatype("jet-engine:cryptography");
exports.host = metatype_1.makeMetatype("jet-engine:host");
exports.localizer = metatype_1.makeMetatype("jet-engine:localizer");
exports.net = metatype_1.makeMetatype("jet-engine:net");
exports.platform = metatype_1.makeMetatype("jet-engine:platform");
exports.plist = metatype_1.makeMetatype("jet-engine:plist");
exports.random = metatype_1.makeMetatype("jet-engine:random");
exports.services = metatype_1.makeMetatype("jet-engine:services");
//# sourceMappingURL=types.js.map